import {
  IControl,
  IFormDocument,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

/**
 * Check that control have background card
 *
 * @param doc
 * @param control
 */
export function isControlHaveBackground(
  doc: IFormDocument,
  control?: IControl,
): boolean {
  const haveFormBackground = doc.metadata?.form?.$nobackground !== 'yes';

  if (haveFormBackground) {
    return true;
  }

  if (!control) {
    return false;
  }

  // @TODO i.ablov think about reducing complexity
  const pages = DocHelper.getFormPages(doc);
  const controlPage = pages.find(page => {
    const controls = DocHelper.getFormControlsFromPage(page);
    const isPageContainControl = controls.some(c => c.$name === control.$name);
    return isPageContainControl;
  });

  if (!controlPage) {
    return false;
  }

  return controlPage.$background === 'yes';
}
